import { render, staticRenderFns } from "./kvSvgIcon.vue?vue&type=template&id=55045f1c&"
import script from "./kvSvgIcon.vue?vue&type=script&lang=js&"
export * from "./kvSvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./kvSvgIcon.vue?vue&type=style&index=0&id=55045f1c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55045f1c')) {
      api.createRecord('55045f1c', component.options)
    } else {
      api.reload('55045f1c', component.options)
    }
    module.hot.accept("./kvSvgIcon.vue?vue&type=template&id=55045f1c&", function () {
      api.rerender('55045f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kiva/kvSvgIcon.vue"
export default component.exports